import { forwardRef } from "react"
import { MinusIcon } from "../Icons"
import { Text } from "../Typography"
import { Flex } from "../Flex"
import StyledTag from "./styles/TagStyle"
import IconButton from "./styles/IconButtonStyle"

type TagOwnProps = Readonly<{
  onRemove: () => void
}>

export type TagProps = TagOwnProps & React.ComponentPropsWithRef<typeof StyledTag>

const Tag: React.FC<TagProps> = forwardRef(({ onRemove, children, ...tagProps }: TagProps, forwardedRef) => (
  <StyledTag ref={forwardedRef} {...tagProps}>
    <Flex alignItems="center">
      <Text>{children}</Text>
      <IconButton onClick={onRemove}>
        <MinusIcon />
      </IconButton>
    </Flex>
  </StyledTag>
))

Tag.displayName = `MultiSelectTag`

export { Tag }
